import React from 'react';
import TopOnePercentBackground from '../../assets/home/TopOnePercentBackground.png'
import TopOnePercent from '../../assets/home/TopOnePercent.png'
import Image from '../../components/general/Image';
import Button from '../../components/general/Button';
import { ROUTES } from '../../routes/RouteList';

const FilterTalent = () => {
  const backgroundImage = {
    backgroundImage: `url(${TopOnePercentBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'cover',
    backgroundRepeat: 'no-repeat',
    color: 'black',
    position: 'relative',
    zIndex: '1',
  }

  const TiltedDiv = (
    <div>
      <div className='w-[15px] h-[15px] bg-primary-color rotate-[45deg]' />
    </div>
  )

  return (
    <section className="" style={backgroundImage}>
      <div className="max-width --layout-padding !pt-[100px] md:!pt-[150px] lg:!pt-[150px] !pb-[50px]" id="filter-talent-bg">
        <div className="">
          <h3 className="text-[30px] lg:text-55 text-center lg:text-left font-semibold">How We Vet the Top 3% <br className='hidden lg:block' /> of Developers</h3>
          <p className='text-[#161515] font-extralight text-center lg:text-left text-[13px] lg:text-[16px]'>
            No AI filters. No shortcuts. Just hands-on, human-led screening at every step.
          </p>
        </div>

        <div className='flex flex-col-reverse lg:flex-row lg:justify-between mt-[40px] gap-[20px]'>
          <div className='lg:w-[45%]'>
            <ul className="">
              <li>
                <div className='flex justify-start items-center gap-[10px]'>
                  <span className="text-[#D9D9D9] font-semibold">1</span>
                  {TiltedDiv}
                  <p className='text-primary-color text-[14px]'>Profile Deep Dive</p>
                </div>
                <h4 className='text-[18px] ml-[24px] my-[10px] pb-[40px] border-l border-primary-color pl-[20px]'>
                  We manually review resumes, LinkedIn profiles, and portfolios to verify experience and background.
                  <br className="hidden lg:block" /> 
                  <span className='font-semibold'>
                    100% Human Verified
                  </span>
                </h4>
              </li>
              <li>
                <div className='flex justify-start items-center gap-[10px]'>
                  <span className="text-[#D9D9D9] font-semibold">2</span>
                  {TiltedDiv}
                  <p className='text-primary-color text-[14px]'>Soft Skills & Communication</p>
                </div>
                <h4 className='text-[18px] ml-[24px] my-[10px] pb-[40px] border-l border-primary-color pl-[20px]'>
                  We assess English fluency, professionalism, and interpersonal skills to ensure client readiness.
                  <br className="hidden lg:block" /> 
                  <span className='font-semibold'>
                    100% Human Verified
                  </span>
                </h4>
              </li>
              <li>
                <div className='flex justify-start items-center gap-[10px]'>
                  <span className="text-[#D9D9D9] font-semibold">3</span>
                  {TiltedDiv}
                  <p className='text-primary-color text-[14px]'>Technical Interviews</p>
                </div>
                <h4 className='text-[18px] ml-[24px] my-[10px] pb-[40px] border-l border-primary-color pl-[20px]'>
                  Senior engineers conduct live coding and scenario-based interviews. No generic tests.
                  <br className="hidden lg:block" /> 
                  <span className='font-semibold'>
                    100% Expert Evaluated
                  </span>
                </h4>
              </li>
              <li>
                <div className='flex justify-start items-center gap-[10px]'>
                  <span className="text-[#D9D9D9] font-semibold">4</span>
                  {TiltedDiv}
                  <p className='text-primary-color text-[14px]'>Final Approval & Listing</p>
                </div>
                <h4 className='text-[18px] ml-[24px] my-[10px] pb-[40px] pl-[20px]'>
                  Only the best — with validated skills, real-world experience, and proven track records — make the cut.
                  <br className="hidden lg:block" /> 
                  <span className='font-semibold'>
                    ~1.5% Pass Rate
                  </span>
                </h4>
              </li>
            </ul>
          </div>
          <div className="lg:w-[50%]">
            <figure><Image src={TopOnePercent} alt="" /></figure>
            <div className="md:flex md:justify-center mt-[20px] gap-[20px] lg:gap-[10px] lg:mt-[50px] lg:ml-[50px]">
              <Button
                href={ROUTES.ABOUT_US}
                className="w-full text-black rounded h-[50px] md:w-[400px] lg:px-[10px] border !border-black text-[0.8rem]"
              >
                Read more about our screening
                <i className="fa-solid fa-arrow-up-right ml-[10px]" />
              </Button>
              <Button
                href={ROUTES.START_HIRING}
                className="w-full bg-primary-color text-black rounded h-[50px] md:w-[300px] mt-[20px] md:mt-0 text-[0.8rem]"
              >
                Hire with confidence
                <i className="fa-solid fa-arrow-up-right ml-[10px]" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilterTalent;